<script setup>
import { computed, inject } from 'vue';
import { useI18n } from 'vue-i18n';
import ColorField from '../../fields/ColorField.vue';
import SliderField from '../../fields/SliderField.vue';
import FontField from '../../fields/FontField.vue';

const ed = inject('emailEditor');
const { t } = useI18n();
const s = computed(() => ed.doc.value.settings || {});
const theme = computed(() => ed.template.value?.theme || {});
const fonts = computed(() => ed.catalog.value?.layout?.fonts);
const set = (key, value) => ed.updateSettings({ [key]: value });
const preheader = computed(() => ed.template.value?.settings?.preheader || '');
const setPreheader = value =>
  ed.updateTemplate({
    settings: { ...(ed.template.value.settings || {}), preheader: value },
  });
</script>

<template>
  <div data-props="document" class="flex flex-col gap-4">
    <label class="flex flex-col gap-1.5">
      <span class="text-xs font-medium text-n-slate-11">{{
        t('EMAIL_TEMPLATES.EDITOR.PROPS.PREHEADER')
      }}</span>
      <input
        class="rounded-lg border border-n-weak bg-n-solid-1 px-2 py-1.5 text-sm"
        :value="preheader"
        maxlength="150"
        @input="setPreheader($event.target.value)"
      />
    </label>
    <SliderField
      :label="t('EMAIL_TEMPLATES.EDITOR.PROPS.WIDTH')"
      :model-value="s.width || 600"
      :min="480"
      :max="800"
      :step="10"
      unit="px"
      @update:model-value="v => set('width', v)"
    />
    <ColorField
      :label="t('EMAIL_TEMPLATES.EDITOR.PROPS.BG_OUTER')"
      :theme="theme"
      :model-value="s.background_outer"
      @update:model-value="v => set('background_outer', v)"
    />
    <ColorField
      :label="t('EMAIL_TEMPLATES.EDITOR.PROPS.BG_INNER')"
      :theme="theme"
      :model-value="s.background_inner"
      @update:model-value="v => set('background_inner', v)"
    />
    <FontField
      :label="t('EMAIL_TEMPLATES.EDITOR.PROPS.FONT')"
      :fonts="fonts"
      :model-value="s.font_family"
      @update:model-value="v => set('font_family', v)"
    />
    <ColorField
      :label="t('EMAIL_TEMPLATES.EDITOR.PROPS.LINK_COLOR')"
      :theme="theme"
      :model-value="s.link_color"
      @update:model-value="v => set('link_color', v)"
    />
    <SliderField
      :label="t('EMAIL_TEMPLATES.EDITOR.PROPS.RADIUS')"
      :model-value="s.radius ?? 12"
      :min="0"
      :max="40"
      unit="px"
      @update:model-value="v => set('radius', v)"
    />
  </div>
</template>
